import React from "react";
import { Skeleton } from "@mui/material";
import {
  StyledMetricCard,
  MetricTitle,
  PieChartContainer,
  PieChartTitle,
  PieChartContent,
  PieChartWrapper,
  PieChartLegend,
  LegendItem,
  LineChartContainer,
  LineChartTitle,
  LineChartContent,
  LineChartWrapper,
  LineChartLegend,
} from "./PerformanceStyles";

export type SkeletonType = "metric-card" | "pie-chart" | "line-chart";

interface PerformanceSkeletonProps {
  type: SkeletonType;
  title: string;
  legendItems?: number;
}

export const PerformanceSkeleton: React.FC<PerformanceSkeletonProps> = ({
  type,
  title,
  legendItems = 4,
}) => {
  switch (type) {
    case "metric-card":
      return (
        <StyledMetricCard>
          <MetricTitle>{title}</MetricTitle>
          {Array(2)
            .fill(null)
            .map((_, index) => (
              <Skeleton
                key={index}
                variant="text"
                width="40%"
                height={28}
                animation="wave"
              />
            ))}
        </StyledMetricCard>
      );
    case "pie-chart":
      return (
        <PieChartContainer>
          <PieChartTitle>{title}</PieChartTitle>
          <PieChartContent>
            <PieChartWrapper>
              <Skeleton
                variant="circular"
                width={160}
                height={160}
                animation="wave"
              />
            </PieChartWrapper>
            <PieChartLegend>
              {Array(legendItems)
                .fill(null)
                .map((_, index) => (
                  <LegendItem key={index}>
                    <Skeleton
                      variant="rectangular"
                      width={30}
                      height={15}
                      animation="wave"
                    />
                    <Skeleton
                      variant="text"
                      width={60}
                      height={20}
                      animation="wave"
                    />
                  </LegendItem>
                ))}
            </PieChartLegend>
          </PieChartContent>
        </PieChartContainer>
      );
    case "line-chart":
      return (
        <LineChartContainer>
          <LineChartTitle>{title}</LineChartTitle>
          <LineChartContent>
            <LineChartWrapper>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={160}
                animation="wave"
              />
            </LineChartWrapper>
            <LineChartLegend>
              <LegendItem>
                <Skeleton
                  variant="rectangular"
                  width={30}
                  height={15}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  width={80}
                  height={20}
                  animation="wave"
                />
              </LegendItem>
              <LegendItem>
                <Skeleton
                  variant="rectangular"
                  width={30}
                  height={15}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  width={80}
                  height={20}
                  animation="wave"
                />
              </LegendItem>
            </LineChartLegend>
          </LineChartContent>
        </LineChartContainer>
      );
    default:
      return null;
  }
};
